import { Main } from "./Main";
import { About } from "./About";
import { Benefits } from "./Benefits";
import { KindFuel } from "./KindFuel";
import {Certificates} from './Certificates'
import { FindUs } from "./FindUs";
import { Bonuses } from "./Bonuses";
import { BonusesProgramme } from "./BonusesProgramme";
import { FAQ } from "./FAQ"
import {Contacts} from './Contacts'

export const Layout = { Main, About, Benefits, KindFuel, Certificates, FindUs, Bonuses, BonusesProgramme, FAQ, Contacts,  };
